import React from 'react';

const LOGO_URL = 'https://static.wixstatic.com/media/47e68b_9ba20c13e75f4752b5585a413624d1cc~mv2.png/v1/fill/w_342,h_72,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Icon%20%2B%20Lutrom%20%2B%20Engineering.png';

const LutromLogo = ({ dark = false, size = 'md' }) => {
  const heights = { sm: 'h-7', md: 'h-9', lg: 'h-12' };
  return (
    <div className="flex items-center">
      <img
        src={LOGO_URL}
        alt="Lutrom Engineering"
        className={`${heights[size] || heights.md} w-auto ${dark ? 'invert brightness-0' : ''}`}
        style={dark ? { filter: 'invert(1) brightness(2)' } : undefined}
      />
    </div>
  );
};

export default LutromLogo;
